<template>
    <div>
        <buttonlist
                @help="help"
                @add="add"
                @search="search"
                @reflash="reflash"
                @exps="exps"
                ref="SetBtn"
        ></buttonlist>
        <el-table
                id="xpane-0"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                size="mini"
                :height="tableHeight"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                ref="singleTable"
        >
            <el-table-column type="selection" v-if="false"></el-table-column>
            <el-table-column show-overflow-tooltip prop="tyear" :label="$t('getapi[1974]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_code" :label="$t('getapi[3437]')"></el-table-column>
            <el-table-column show-overflow-tooltip prop="item_name" :label="$t('getapi[546]')"></el-table-column>
            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                <template slot-scope="scope">
                    <el-button @click.native.prevent="editInfo(scope.row)" type="text" size="small">{{ $t('getapi[34]') }}
                    </el-button>
                    <el-popconfirm
                            :confirmButtonText="$t('getapi[937]')"
                            :cancelButtonText="$t('getapi[6]')"
                            icon="el-icon-info"
                            iconColor="red"
                            :title="$t('getapi[637]')"
                            @onConfirm="del(scope.row)"
                    >
                        <el-button slot="reference" type="text" size="small">{{ $t('getapi[40]') }}</el-button>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </el-table>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="CItemInfo" ref="ser" @getser="serclick"></serce>

        <!-- 编辑弹框 -->
        <el-dialog v-dialogDrag :visible.sync="isShowDetail" :title="$t('getapi[34]')" width="40%" :close-on-click-modal="false">
            <el-divider></el-divider>
            <div :style="{border:'1px solid #DCDFE6'}">
                <table>
                    <tr>
                        <td>{{$t('getapi[1974]')}}</td>
                        <td><el-input v-model="dataList.tyear" :placeholder="$t('getapi[1974]')"></el-input></td>
                        <td>{{$t('getapi[3437]')}}</td>
                        <td><el-input v-model="dataList.item_code" :placeholder="$t('getapi[3437]')"></el-input></td>
                    </tr>
                    <tr>
                        <td>{{$t('getapi[546]')}}</td>
                        <td><el-input v-model="dataList.item_name" :placeholder="$t('getapi[546]')"></el-input></td>
                    </tr>
                </table>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
				<el-button @click="isShowDetail = false" size="mini">{{ $t('getapi[6]') }}</el-button>
				<el-button type="primary" @click="save" :loading="loading"
                           :disabled="loading" size="mini">{{ $t('getapi[937]') }}</el-button>
			</span>
        </el-dialog>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';

    export default {
        name: '3_requireitem',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                isShowDetail: false,
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('3_requireitem'), // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                dataList: {},
                scrollTop:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(0)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem('userData');
            that.authority();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6686]"),this.$t("getapi[6685]"));
            },
            authority() {
                let that = this
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('3_requireitem',val)
                this.getView();
                this.authority();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
                this.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'CItemInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndexs,
                    Param: datac
                };
                that.$http.urlpost('/Fin/Require/GetCItemInfoView', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.authority();
                    }
                })
            },
            add() {
                let that = this
                that.isShowDetail = true;
                that.dataList = {
                    old_tyear: '',
                    old_item_code: '',
                    tyear: '',
                    item_code: '',
                    item_name: ''
                }
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[6686]')
                };
                that.$http.urlpost('/Fin/Require/GetCItemInfoViewToExecl', parm, function (res) {
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            //编辑
            editInfo(row) {
                let that = this;
                that.isShowDetail = true
                that.dataList = {
                    old_tyear: row.tyear,
                    old_item_code: row.item_code,
                    tyear: row.tyear,
                    item_code: row.item_code,
                    item_name: row.item_name
                }
            },
            save(){
                let that = this
                that.loading = true;
                let parm = that.dataList
                that.$http.urlpost('/Fin/Require/SaveRequireItem', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                        that.isShowDetail = false;
                        that.getView();
                    }
                    that.loading = false;
                });
            },
            del(row){
                let that = this;
                let parm = {
                    old_tyear: row.tyear,
                    old_item_code: row.item_code,
                    tyear: row.tyear,
                    item_code: row.item_code,
                    item_name: row.item_name
                }
                that.$http.urlpost('/Fin/Require/DeleteRequireItem', parm, function (res) {
                    that.getView();
                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg))
                });
            }
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }
    /deep/.yellow{
        background:#fff7bf
    }
    /deep/.green{
        background: #c4ffaf
    }
    /deep/.purple{
        background: #edc6ff
    }
</style>
